import React, { useEffect } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import SafePureComponent from '../shared/SafePureComponent';
import { isSinglePackage } from '../../reducers/packages';
import { tabButtonContentContainerStyle } from '../ContactSeller/ContactSellerOptions/ContactButtonStyles/TabContent/TabContent.ve.css';
import { metric } from '../../utils/metric';
import SinglePackage from './SinglePackage';
import TriplePackage from './TriplePackage';
import './style.scss';

const PackagesTabs = ({ shouldRender = true, isSinglePackage }) => {
    const { seller } = useGigPageContext();

    useEffect(() => {
        if (shouldRender) {
            metric.count('gig_page.packages_tabs.shown');
        }
    }, [shouldRender]);

    if (!shouldRender) {
        return null;
    }

    return (
        <Container
            className={seller.hourlyRate ? classNames('hourly-indications', 'packages-tabs-wrapper', tabButtonContentContainerStyle)
                    : 'default packages-tabs-wrapper'
            }
        >
            {isSinglePackage ? <SinglePackage /> : <TriplePackage />}
        </Container>
    );
};

PackagesTabs.propTypes = {
    shouldRender: bool,
    isSinglePackage: bool,
};

const mapStateToProps = ({ packages, customOrder }) => ({
    shouldRender: packages.packageList.length > 0,
    isSinglePackage: isSinglePackage(packages),
    customOrder,
});

export { PackagesTabs };
export default SafePureComponent(connect(mapStateToProps)(PackagesTabs));
